import { Navigate } from 'react-router-dom';

import { NBA_MARKET_COMMON_MARKET_DROP_CARD } from '@sorare/core/src/constants/__generated__/routes';

const DropCardPage = () => {
  return <Navigate to={NBA_MARKET_COMMON_MARKET_DROP_CARD} replace />;
};

export default DropCardPage;
